import styled from 'styled-components';

export const StyledTableContainer = styled.div`
  // White background to match the designs proposed by the design team. It can't be transparent since Fixed columns will bug out.
  .ant-table-thead > tr > th {
    background: white;
  }

  .ant-table-thead
    > tr
    > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not(
      [colspan]
    )::before {
    background-color: transparent;
  }

  .ant-table-container {
    font-family: Inter, sans-serif;
    font-weight: 400;
    font-size: 1.6rem;
    line-height: 2.4rem;
  }

  .ant-empty-description {
    color: #232c3b !important;
    font-weight: 400;
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: ${({ theme }) => theme.noodera.spacing.x6};

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: ${({ theme }) => theme.noodera.spacing.x6};
  }
`;

export const PaginationControls = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.noodera.spacing.x4};
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: ${({ theme }) => theme.noodera.spacing.x6};
  }
`;

export const PaginationStats = styled.div`
  ${({ theme }) => theme.noodera.fontTypes.font5};
`;
